// ---- providers.ts ------------------------------------
import { ethers } from 'ethers';
import { environment } from '../../environments/environment';  // ← ajuste le chemin

/** Read-only provider per chain */
export function getReadonlyProvider(chainId: number): ethers.JsonRpcProvider {
  switch (chainId) {
    case 1: // Ethereum
      return new ethers.JsonRpcProvider("https://eth-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN");

    case 42161: // Arbitrum
      return new ethers.JsonRpcProvider("https://arb-mainnet.g.alchemy.com/v2/id2ETOtmTy1BpEYYsngoBNiBwnx2bGeD");

    case 137: // Polygon
      return new ethers.JsonRpcProvider("https://polygon-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN");

    case 10: // Optimism
      return new ethers.JsonRpcProvider("https://opt-mainnet.g.alchemy.com/v2/YOUR_KEY");

    case 8453: // Base
      return new ethers.JsonRpcProvider("https://base-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN");

    case 43114: // Avalanche
      return new ethers.JsonRpcProvider("https://avax-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN");

    case 56: // BNB Chain
      return new ethers.JsonRpcProvider("https://bnb-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN");

    default:
      throw new Error(`No provider configured for chainId=${chainId}`);
  }
}
